import { inject, injectable } from "inversify";
import {
  ClientPortalCaseDetailsModel,
  ClientPortalCaseFiltersModel,
  ClientPortalCaseModel,
  ClientPortalNewCaseModel,
  ICPLClientPortalCasesClient,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalCasesService {
  getCases(caseFiltersModel: ClientPortalCaseFiltersModel): Promise<Array<ClientPortalCaseModel>>;
  getCaseDetails(caseID: number): Promise<ClientPortalCaseDetailsModel>;
  createCase(newCaseModel: ClientPortalNewCaseModel): Promise<number>;
}

@injectable()
export class ClientPortalCasesService implements IClientPortalCasesService {
  @inject(SERVICE_TYPES.CPLClientPortalCasesClient) cplClientPortalCasesClient!: ICPLClientPortalCasesClient;

  async getCases(caseFiltersModel: ClientPortalCaseFiltersModel): Promise<ClientPortalCaseModel[]> {
    return await this.cplClientPortalCasesClient.getCases(caseFiltersModel);
  }

  async getCaseDetails(caseID: number): Promise<ClientPortalCaseDetailsModel> {
    return await this.cplClientPortalCasesClient.getCaseDetails(caseID);
  }

  async createCase(newCaseModel: ClientPortalNewCaseModel): Promise<number> {
    return await this.cplClientPortalCasesClient.createCase(newCaseModel);
  }
}
